<template>
  <div
    v-if="error"
    class="p-6 glass-card text-center text-xl flex flex-col items-center gap-4 absolute w-full min-h-full"
    role="alert"
  >
    <strong class="font-bold">Error! {{ errorCode }}</strong>
    <span class="block sm:inline">{{ error }}</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-circle-x-icon lucide-circle-x w-20 h-20 text-red-600"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="m15 9-6 6" />
      <path d="m9 9 6 6" />
    </svg>
  </div>
  <div>
    
  </div>
</template>

<script>
export default {
    props: {
      error: {
        type: String,
        default: ''
      },
      errorCode: {
        type: String,
        default: ''
      },
    }
  }
</script>